import React, { useEffect } from "react"
import { Row, Col } from "react-bootstrap"
import {
  Formik,
  Form as FormikForm,
  Field,
  //useFormikContext
} from "formik"
import * as Yup from "yup"
import { useDispatch, useSelector, shallowEqual, batch } from "react-redux"
import {
  updateUiData,
  updateValidFormData,
  getRequiredDocuments,
  getPolicyInfo,
} from "../redux/actions"
import FormTextbox from "../components/shared/formTextbox"
import FormFieldDisableAutoComplete from "../components/shared/formFieldDisableAutoComplete"
import FormRadioButton from "../components/shared/formRadioButton"
import FormAmountTextBox from "../components/shared/formAmountTextBox"
import * as Regex from "../common/regex"
import * as ErrorMessage from "../common/errorMessage"
import * as Constants from "../common/constants"
import { missingInfoAlert } from "../services/sweetalertService"
import * as API from "../services/httpService"
import { navigate } from "gatsby"
import * as CommonFunction from "../common/function"

const Index = ({ location }) => {
  const uiData = useSelector(state => state.uiData, shallowEqual)
  const claimData = useSelector(state => state.claimData, shallowEqual)
  const dispatch = useDispatch()
  const formRef = React.useRef()

  useEffect(() => {
    if (uiData.maxPageNumber === 1) {
      const GetDataPromise = API.apiPostRequest("/Claim/GetData", null, null)

      Promise.all([GetDataPromise])
        .then(values => {
          batch(() => {
            if (values[0].data) {
              dispatch(
                updateValidFormData("claimWorkCompDetailModel", values[0].data)
              )
            }
            dispatch(updateUiData("showLoading", false))
          })
        })
        .catch(error => {
          navigate("errorOccurred")
        })
    } else {
      // Delete all uploaded file
      if (uiData.claimUploadListModel.length > 0) {
        let deleteMultipleFileArray = []

        uiData.claimUploadListModel.forEach((UploadedItem, UploadedKey) => {
          let deleteFileInfo = {}
          deleteFileInfo.fName = UploadedItem.fileName
          deleteFileInfo.folderName = uiData.folderName
          deleteMultipleFileArray.push(deleteFileInfo)
        })

        API.apiPostRequest(
          "/Claim/ClaimDocsMultipleDelete",
          deleteMultipleFileArray,
          null
        ).then(response => {
          dispatch(updateUiData("claimUploadListModel", []))
        })
      }
    }

    CommonFunction.updateUiCurrentPageNumber(dispatch, location.href)
  }, [])

  const formikSchema = Yup.object().shape({
    policyNumber: Yup.string()
      .length(8, ErrorMessage.policyNumberLength)
      .required(ErrorMessage.policyNumberRequired)
      .matches(Regex.policyPattern, ErrorMessage.policyNumber),
    policyHolderName: Yup.string()
      .required(ErrorMessage.policyHolderName)
      .matches(Regex.namepattern, ErrorMessage.policyHolderName),
    // employerAddress: Yup.string().required(ErrorMessage.employerAddress),
    employerEmail: Yup.string()
      .required(ErrorMessage.claimantEmail)
      .email(ErrorMessage.claimantEmail),
    employerTel: Yup.string()
      .required(ErrorMessage.employerTel)
      .matches(Regex.phonepattern, ErrorMessage.employerTel),
    gstNumber: Yup.string().when("gstRegistration", {
      is: true,
      then: Yup.string().required(ErrorMessage.gstNumber),
    }),
  })

  const generateFolderName = draftFolderPrefix => {
    let dd = new Date()
    let ss =
      "" +
      dd.getYear() +
      dd.getMonth() +
      dd.getDate() +
      dd.getHours() +
      dd.getMinutes() +
      dd.getSeconds()
    return draftFolderPrefix + ss
  }

  return (
    <Formik
      initialValues={Object.assign({}, claimData["claimWorkCompDetailModel"])}
      enableReinitialize={true}
      validationSchema={formikSchema}
      validateOnMount={true}
      innerRef={formRef}
      onSubmit={(values, actions) => {
        dispatch(updateValidFormData("claimWorkCompDetailModel", values))
        dispatch(getRequiredDocuments(Constants.basicCoverageDetailId))
        dispatch(updateUiData("showLoading", true))

        const sessionIdAndFolderName = generateFolderName(
          uiData.draftFolderPrefix
        )
        dispatch(updateUiData("folderName", sessionIdAndFolderName))

        const getPolicyInfoRequestModel = {
          PolicyNumber: values.policyNumber,
          PolicyHolderName: values.policyHolderName,
          NRIC: values.NRIC,
          SessionId: sessionIdAndFolderName,
        }

        dispatch(getPolicyInfo(getPolicyInfoRequestModel))
      }}
    >
      {({ handleSubmit, isSubmitting, isValid, values, errors }) => (
        <FormikForm onSubmit={handleSubmit}>
          <Row>
            <div className="title text-center">
              {uiData.claimFormTitle} e-Claims
            </div>
            <div className={"containerBody"}>
              <div className="formContainer">
                <div className="marginBottom25px">
                  <div className={"titleText "}>Policy Information</div>
                </div>
                <div>
                  {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
                  <Field
                    textDesc={"Disable Auto Complete"}
                    name="disableAutoComplete"
                    component={FormFieldDisableAutoComplete}
                  />
                  <Field
                    textDesc="Policy Number"
                    maxLength={20}
                    name="policyNumber"
                    component={FormTextbox}
                    toUpperCase={true}
                  />
                  <Field
                    textDesc="Intermediary"
                    maxLength={50}
                    name="intermediary"
                    component={FormTextbox}
                  />
                </div>

                <div className="marginBottom25px marginTop30px">
                  <div className={"titleText "}>The Employer</div>
                </div>
                <div>
                  <Field
                    textDesc="Name of Insured as per policy schedule"
                    maxLength={100}
                    name="policyHolderName"
                    component={FormTextbox}
                    toUpperCase={true}
                  />
                  <Field
                    textDesc="Nature of Business"
                    maxLength={50}
                    name="businessNature"
                    targetModel="address"
                    component={FormTextbox}
                  />
                  <Field
                    textDesc="Address"
                    maxLength={100}
                    name="employerAddress"
                    component={FormTextbox}
                  />
                  <Field
                    textDesc="Email"
                    maxLength={100}
                    name="employerEmail"
                    component={FormTextbox}
                  />
                  <Field
                    textDesc="Business Tel Number"
                    maxLength={10}
                    name="employerTel"
                    component={FormTextbox}
                  />
                  <Field
                    textDesc="Total Number of Employees"
                    maxLength={10}
                    name="numberOfEmployees"
                    placeholder=" "
                    decimalScale={0}
                    component={FormAmountTextBox}
                  />
                  <Field
                    textDesc="GST Registration"
                    name="gstRegistration"
                    component={FormRadioButton}
                  />
                  {values.gstRegistration && (
                    <>
                      {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
                      <Field
                        textDesc={"Disable Auto Complete"}
                        name="disableAutoComplete"
                        component={FormFieldDisableAutoComplete}
                      />
                      <Field
                        textDesc="GST Number"
                        maxLength={20}
                        name="gstNumber"
                        component={FormTextbox}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          </Row>
          <Row>
            <div className="submitFormCenterBtnDiv">
              <button
                className="btnSubmitForm fontWeightBold"
                type="submit"
                // disabled={isSubmitting}
              >
                <b>Continue</b>
              </button>
            </div>
          </Row>
          <HandleFormSubmit formRef={formRef} isSubmitting={isSubmitting} />
        </FormikForm>
      )}
    </Formik>
  )
}

const HandleFormSubmit = ({ formRef, isSubmitting }) => {
  React.useEffect(() => {
    if (isSubmitting) {
      formRef.current.validateForm().then(errors => {
        if (Object.entries(errors).length !== 0) {
          missingInfoAlert()
          formRef.current.setSubmitting(false)
        }
      })
    }
  }, [isSubmitting])
  return null
}
export default Index
